module.exports = __webpack_public_path__ + "static/img/001.7d5715ec.png";